import * as types from '@/store/mutation-types'
import { DISPLAY_TYPE_MAP } from '@/constants'

export default {
  setUser({ commit }, data) {
    commit(types.SET_USER, data)
  },
  unsetUser({ commit }) {
    commit(types.SET_USER, {
      id: '',
      name: '',
      picture: ''
    })
  },

  // devices
  setDevices({ commit }, data) {
    commit(types.SET_DEVICES, data)
  },
  addDevice({ commit }, data) {
    commit(types.ADD_DEVICES, data)
  },
  updateDeviceBy({ commit, state }, { id, key, value }) {
    const index = state.devices.findIndex(d => d.id === id)
    if (index === -1) {
      return
    }
    const data = Object.assign({}, state.devices[index])
    data[key] = value
    commit(types.UPDATE_DEVICE, { index: index, data: data })
  },
  unSetUserDevice({ commit, state }, device) {
    const index = state.devices.findIndex(d => d.id === device.id)
    if (index === -1) {
      return
    }
    const data = Object.assign({}, state.devices[index])
    data.is_set = false
    commit(types.UPDATE_DEVICE, { index: index, data: data })
  },

  // infodevice
  setInfoDeviceId({ commit }, id) {
    commit(types.SET_INFO_DEVICE_ID, id)
  },
  unsetInfoDeviceId({ commit }) {
    commit(types.SET_INFO_DEVICE_ID, '')
  },

  doReloadMap({ commit }) {
    commit(types.UPDATE_RELOAD_MAP, true)
  },
  completeReloadMap({ commit }) {
    commit(types.UPDATE_RELOAD_MAP, false)
  },

  // provider
  setProvider({ commit }, data) {
    commit(types.SET_PROVIDER, data)
  },
  unsetProvider({ commit }) {
    commit(types.SET_PROVIDER, {
      oidcProviderName: '',
      idpIdentifier: '',
      displayType: DISPLAY_TYPE_MAP,
      groupId: '',
      groupName: '',
      groupLineOfficialAccountName: ''
    })
  }
}
